import { StrictMode } from 'react';
import './App.css';
import Bars from './components/Bars';
import CitiesOverview from './components/CitiesOverview';
import CityDetails from './components/CityDetails';
import Degrees from './components/Degrees';
import Endlocations from './components/Endlocations';
import EventMissed from './components/EventMissed';
import Partners from './components/Partners';
import CityDegrees from './components/CityDegrees';
import CityFrontpage from './components/CityFrontpage';
import BarsDetails from './components/BarsDetails';
import CityName from './components/CityName';
import EventInfos from './components/EventInfos';

function App(params) {

  const shortcode = params.shortcode;

  let components = {
    cities_overview:         <CitiesOverview data={params.data} />,
    city_details:            <CityDetails data={params.data}  />,
    endlocation_information: <Endlocations data={params.data} />,
    bars:                    <Bars data={params.data} />,
    degrees:                 <Degrees data={params.data} />,
    partner:                 <Partners data={params.data} />,
    event_missed:            <EventMissed data={params.data} />,
    city_degrees:            <CityDegrees data={params.data} />,
    cities_frontpage:        <CityFrontpage data={params.data} />,
    city_bars_details:       <BarsDetails data={params.data} />,
    get_city_name:           <CityName data={params.data} />,
    event_infos:             <EventInfos data={params.data} />
  };

  if ( ! components[shortcode] ) {
    return( <StrictMode><div>{`Missing shortcode switch case: ${shortcode}`}</div></StrictMode> );
  }

  return(
    <StrictMode>
      {components[shortcode]}
    </StrictMode>
  );

}

export default App;
